/**
 * The project picker as a screen header control (SC-U15 / SC-U16).
 *
 * It renders only once a project is actually selected. In every other state
 * `RequireActiveProject` takes over the body of the screen and shows a picker
 * of its own next to the explanation — rendering this one as well put two
 * identical selectors on the page, one right above the other.
 */

import { FC } from 'react';
import { Box } from '@material-ui/core';
import { useActiveProject } from './ActiveProjectContext';
import { ProjectSelector } from './ProjectSelector';

export interface ActiveProjectBarProps {
  /** Rendered disabled while a screen is mid-operation. */
  disabled?: boolean;
}

export const ActiveProjectBar: FC<ActiveProjectBarProps> = ({ disabled }) => {
  const { status } = useActiveProject();

  if (status !== 'ready') {
    return null;
  }

  return (
    <Box mb={2}>
      <ProjectSelector disabled={disabled} />
    </Box>
  );
};

export default ActiveProjectBar;
